// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"878d8c7883605331","6831":"7b41fdd9901a8c3f","8503":"296d024790dc81a4","9683":"6a6bb08b17a7e8a1"}[chunkId] + ".js";
};